const TOGGLE_APP_THEME = 'TOGGLE_APP_THEME';
const TOGGLE_SIDE_MENU_OPEN = 'TOGGLE_SIDE_MENU_OPEN';
const ADD_POPUP_TOGGLE = 'ADD_POPUP_TOGGLE';
const WORD_SET_POPUP_TOGGLE = 'WORD_SET_POPUP_TOGGLE';

const SELECT_WORD_SET = 'SELECT_WORD_SET';
const SELECT_WORD_SET_IS_LOADING = 'SELECT_WORD_SET_IS_LOADING';
const SELECT_WORD_SET_IS_ERROR = 'SELECT_WORD_SET_IS_ERROR';

const ADD_NEW_WORD = 'ADD_NEW_WORD';
const ADD_NEW_WORD_IS_LOADING  = 'ADD_NEW_WORD_IS_LOADING ';
const ADD_NEW_WORD_IS_ERROR = 'ADD_NEW_WORD_IS_ERROR';
const REMOVE_SELECTED_WORD_SET = 'REMOVE_SELECTED_WORD_SET';

const SET_USER_WORDS = 'SET_USER_WORDS';
const SET_USER_WORDS_IS_LOADING = 'SET_USER_WORDS_IS_LOADING';
const SET_USER_WORDS_IS_ERROR = 'SET_USER_WORDS_IS_ERROR';

const RESET_WORD_PROGRESS = 'RESET_WORD_PROGRESS';
const DELETE_WORD = 'DELETE_WORD';

const TOGGLE_TRAINING = 'TOGGLE_TRAINING';
const SET_WORDS_TO_TRAIN = 'SET_WORDS_TO_TRAIN';
const SET_WORDS_TO_TRAIN_IS_LOADING = 'SET_WORDS_TO_TRAIN_IS_LOADING';
const SET_WORDS_TO_TRAIN_IS_ERROR = 'SET_WORDS_TO_TRAIN_IS_ERROR';
const SET_RANDOM_WORD_TO_GUESS = 'SET_RANDOM_WORD_TO_GUESS';
const SET_TRAINING_STATUS = 'SET_TRAINING_STATUS';
const REMOVE_GUESSED_WORD = 'REMOVE_GUESSED_WORD';

export {
  TOGGLE_APP_THEME,
  SELECT_WORD_SET,
  SELECT_WORD_SET_IS_LOADING,
  SELECT_WORD_SET_IS_ERROR,
  REMOVE_SELECTED_WORD_SET,
  ADD_POPUP_TOGGLE,
  ADD_NEW_WORD,
  ADD_NEW_WORD_IS_LOADING,
  ADD_NEW_WORD_IS_ERROR,
  TOGGLE_SIDE_MENU_OPEN,
  SET_USER_WORDS,
  SET_USER_WORDS_IS_ERROR,
  SET_USER_WORDS_IS_LOADING,
  RESET_WORD_PROGRESS,
  DELETE_WORD,
  TOGGLE_TRAINING,
  SET_WORDS_TO_TRAIN,
  SET_RANDOM_WORD_TO_GUESS,
  SET_TRAINING_STATUS,
  REMOVE_GUESSED_WORD,
  SET_WORDS_TO_TRAIN_IS_ERROR,
  SET_WORDS_TO_TRAIN_IS_LOADING,
  WORD_SET_POPUP_TOGGLE
}